import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const HouseRentalIcon = ({
  title = 'HouseRental',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 64 64" {...props}>
    <defs>
      <path id="a" d="M20.444 18.667h5.333v7.111h-5.333z" />
      <path id="b" d="M8 31.111h7.111V40H8z" />
      <path id="c" d="M31.111 31.111h7.111V40h-7.111z" />
      <mask
        id="d"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="5.333"
        height="7.111"
        fill="#fff"
      >
        <use xlinkHref="#a" />
      </mask>
      <mask
        id="e"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="7.111"
        height="8.889"
        fill="#fff"
      >
        <use xlinkHref="#b" />
      </mask>
      <mask
        id="f"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="7.111"
        height="8.889"
        fill="#fff"
      >
        <use xlinkHref="#c" />
      </mask>
    </defs>
    <g transform="translate(9 8)" stroke="currentColor" fill="none" fillRule="evenodd">
      <path
        strokeLinejoin="round"
        d="M41.27 20.56v27.012H5.333V20.905M.903 20.475h13.295l8.913-10.666 9.188 10.689h13.135V.141H.875z"
      />
      <use mask="url(#d)" strokeWidth="2" xlinkHref="#a" />
      <use mask="url(#e)" strokeWidth="2" xlinkHref="#b" />
      <use mask="url(#f)" strokeWidth="2" xlinkHref="#c" />
      <path d="M18.818 47.438V34.01s-.191-4.173 4.394-4.173c4.584 0 4.393 4.15 4.393 4.15v13.287" />
    </g>
  </CreateIconComponent>
);

export default HouseRentalIcon;
